import React, { Fragment } from "react";
import Bluecta from "../../layouts/Bluecta";
import Gallery from "./Gallery";
import Info from "./Info";
import Services from "./Services";
import BsInfo from "./Bsinfo";
import { useTranslation } from "react-i18next";

const ManagementContent = () => {
  const {t}= useTranslation();
    let data = {
        title:t("Property Management"),
        para:t("If you enjoying"),
        picture:"/assets/img/listings-list/Managment.jpg"
    }

  return (
    <Fragment>
      <BsInfo data={data}  />
      <Services />
      <Gallery />
      <div className="section pt-0">
        <Bluecta />
      </div>
    </Fragment>
  );
};

export default ManagementContent;
